module.exports = __webpack_public_path__ + "static/media/google_assistant_48.32708903.svg";